// La chiave serve per identificare il valore salvato in localStorage
export const AUTH_LOCAL_STORAGE_KEY = "agenti-auth";
